import React from 'react'
import PropTypes from 'prop-types'
import { Table, ProgressBar } from 'react-bootstrap'
import { Pagination } from '@CommonComponents/buttons'
import { getBarStyle } from '../../utils'

class StudentTable extends React.Component {
  render() {
    let component = this
    let rows = []
    this.props.analytics.forEach(function (ea) {
      let parasPercentRound = Math.round(ea.paras_percent * 10) / 10
      let videosPercentRound = Math.round(ea.videos_percent * 10) / 10
      let activitiesPercentRound = Math.round(ea.activities_percent * 10) / 10
      let meanActivitiesPercentRound =
        Math.round(ea.mean_activities_percent * 10) / 10
      let simulationsPercentRound =
        Math.round((ea.simulations_percent || 0) * 10) / 10
      rows.push(
        <tr key={ea.user_id}>
          <td>
            <a
              href={`/course/progress/${component.props.coursenum}/${ea.user_id}/root/`}
            >
              {ea.last_name}, {ea.first_name}
            </a>
          </td>
          <td>
            <ProgressBar
              now={parasPercentRound}
              label={`${parasPercentRound}%`}
              variant={getBarStyle(parasPercentRound)}
            />
          </td>
          <td>
            <ProgressBar
              now={videosPercentRound}
              label={`${videosPercentRound}%`}
              variant={getBarStyle(videosPercentRound)}
            />
          </td>
          <td>
            <ProgressBar
              now={activitiesPercentRound}
              label={`${activitiesPercentRound}%`}
              variant={getBarStyle(activitiesPercentRound)}
            />
          </td>
          <td>
            <ProgressBar
              now={meanActivitiesPercentRound}
              label={`${meanActivitiesPercentRound}%`}
              variant={getBarStyle(meanActivitiesPercentRound, false)}
            />
          </td>
          {component.props.showSimulations && (
            <td>
              <ProgressBar
                now={simulationsPercentRound}
                label={`${simulationsPercentRound}%`}
                variant={getBarStyle(simulationsPercentRound)}
              />
            </td>
          )}
        </tr>
      )
    })
    // The server sends a page count and no page size, so each page counts as
    // one.
    let pagination = label =>
      this.props.totalPages > 1 ? (
        <Pagination
          label={label}
          currentPage={this.props.activePage}
          rate={1}
          total={this.props.totalPages}
          setCurrentPage={this.props.handlePageChange}
          failureMessage={this.props.failureMessage}
        />
      ) : null
    return (
      <div className="student_table_container">
        {pagination('Pagination, top')}
        <Table striped bordered hover className="table-sm">
          <thead>
            <tr>
              <th
                onClick={() => {
                  this.props.handleTableFilterChange('student')
                }}
              >
                Student
              </th>
              <th
                onClick={() => {
                  this.props.handleTableFilterChange('reading')
                }}
              >
                Total Reading Completion
              </th>
              <th
                onClick={() => {
                  this.props.handleTableFilterChange('video')
                }}
              >
                Total Video Completion
              </th>
              <th
                onClick={() => {
                  this.props.handleTableFilterChange('assessment')
                }}
              >
                Total Assessment Completion
              </th>
              <th
                onClick={() => {
                  this.props.handleTableFilterChange('avgAssessment')
                }}
              >
                Average Assessment Performance
              </th>
              {this.props.showSimulations && <th>Learning Activity Completion</th>}
            </tr>
          </thead>
          <tbody>{rows}</tbody>
        </Table>
        {pagination('Pagination, bottom')}
      </div>
    )
  }
}

StudentTable.propTypes = {
  analytics: PropTypes.array,
  coursenum: PropTypes.string,
  totalPages: PropTypes.number,
  activePage: PropTypes.number,
  handlePageChange: PropTypes.func,
  handleTableFilterChange: PropTypes.func,
  showSimulations: PropTypes.bool,
  failureMessage: PropTypes.object,
}

export default StudentTable
